import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 4.997a6 6 0 0 0-4.245 1.758l-1.412 1.413a1 1 0 0 0 1.414 1.414l1.413-1.413a4.002 4.002 0 1 1 5.66 5.661l-1.412 1.413a1 1 0 0 0 1.414 1.414l1.413-1.412A6.003 6.003 0 0 0 21 4.997M13 6a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zM21 23a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zM5 12a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1M23 19a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zM9.582 15.343a1 1 0 0 1 0 1.414L8.17 18.169a4.003 4.003 0 1 0 5.66 5.661l1.413-1.412a1 1 0 1 1 1.414 1.414l-1.412 1.412a6.003 6.003 0 0 1-8.49-8.489l1.413-1.412a1 1 0 0 1 1.414 0"
    />
  </svg>
);
const SvgIconLinkBreak = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconLinkBreak);
export default Memo;
